import { c as _c } from "react-compiler-runtime";
import userInfo from 'hub-http/userInfo';
import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import UserInfoContext from '../contexts/UserInfoContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UserInfoProvider(t0) {
  "use memo";

  const $ = _c(5);
  const {
    children
  } = t0;
  const [userInfoData, setUserInfoData] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      userInfo().then(data => {
        setUserInfoData(data);
      }).catch(_temp);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== children || $[3] !== userInfoData) {
    t3 = /*#__PURE__*/_jsx(UserInfoContext.Provider, {
      value: userInfoData,
      children: children
    });
    $[2] = children;
    $[3] = userInfoData;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(error) {
  Raven.captureException(error, {
    fingerprint: ["Error loading the userInfo in the collaboration sidebar"]
  });
}